// [PHASE-5 2026-10] Pure helpers for the renewal screen.

/**
 * The date to show as "ended on", or null. Only a date that has PASSED ended
 * anything: a suspended (or cancelled) school can have an end date still in
 * the future, and "ended on <next March>" would be false.
 */
export function renewalEndedOn(info, now = Date.now()) {
  if (!info) return null;
  const value = info.is_trial ? info.trial_ends_at : info.subscription_ends_at;
  if (!value) return null;
  const at = Date.parse(value);
  return Number.isFinite(at) && at <= now ? value : null;
}

// ── Contact links (the contact comes from platform settings, never from here) ──

/** tel: link for a phone number as typed in settings ("+000 11 22-33-44"), or ''. */
export function telHref(phone) {
  const raw = String(phone || '').trim();
  const digits = raw.replace(/[^\d]/g, '');
  if (!digits) return '';
  return `tel:${raw.startsWith('+') ? '+' : ''}${digits}`;
}

/** mailto: link, or '' for anything that is not a plain address. */
export function mailtoHref(email) {
  const v = String(email || '').trim();
  return /^[^\s@<>"]+@[^\s@<>"]+$/.test(v) ? `mailto:${v}` : '';
}

/** wa.me link (digits only, as WhatsApp wants), or ''. */
export function whatsappHref(number) {
  const digits = String(number || '').replace(/[^\d]/g, '');
  return digits ? `https://wa.me/${digits}` : '';
}
